import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/laboratoristas';
import LaboratoristaCrear from './LaboratoristaCrear';

const ms2p = state => {
    return {
        ...state.laboratoristas,
    }
}

const md2p = { ...actions };

export default connect(ms2p, md2p)(LaboratoristaCrear);